// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"E3-z","dimensionLabel":"F3-z","styleChooserControlWrapper":"G3-z","styleChooserControl":"H3-z","disabled":"I3-z","giftCard":"J3-z","styleChooserText":"K3-z"};